import { render, staticRenderFns } from "./Clause.vue?vue&type=template&id=3cd5e080&scoped=true&"
import script from "./Clause.vue?vue&type=script&lang=js&"
export * from "./Clause.vue?vue&type=script&lang=js&"
import style0 from "./Clause.vue?vue&type=style&index=0&id=3cd5e080&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd5e080",
  null
  
)

export default component.exports